const ShoePickerNavigation = {
	step: 1,
	setCurrentSlide: null,
};

export default {
	ShoePickerNavigation,
};
